<template>
  <div class="zj-directory-config">
    <div class="preserve-top clearfix"></div>
    <div class="contents-table clearfix">
      <div class="contents-table-left">
        <p class="cue-text">点选下面的称谓的选项，您可以在右侧预览效果，并保存修改后的名称：</p>
        <div class="dashed-border">
          <div class="layer-top">
            <h3 class="layer-name">一级层次名称</h3>
          </div>
          <div class="chleckd-list">
            <el-radio-group v-model="radio1">
              <div class="input-radio" v-for="(item1, key) in num1" :key="key" style="float:left;">
                <el-radio
                  @change="radio1_change(item1.name, item1.num);"
                  :label="item1.lab"
                >{{ item1.name }}</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div class="dashed-border">
          <div class="layer-top">
            <h3 class="layer-name">二级层次名称</h3>
          </div>
          <div class="chleckd-list">
            <el-radio-group v-model="radio2">
              <div class="input-radio" v-for="(item2, key) in num2" :key="key" style="float:left;">
                <el-radio
                  @change="radio2_change(item2.name, item2.num);"
                  :label="item2.lab"
                >{{ item2.name }}</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div class="dashed-border">
          <div class="layer-top">
            <h3 class="layer-name">三级层次名称</h3>
          </div>
          <div class="chleckd-list">
            <el-radio-group v-model="radio3">
              <div class="input-radio" v-for="(item3, key) in num3" :key="key" style="float:left;">
                <el-radio
                  @change="radio3_change(item3.name, item3.num);"
                  :label="item3.lab"
                >{{ item3.name }}</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="contents-table-right">
        <p class="result-text">实时效果：
          <!-- <el-button type="success" @click="saveRadioChange();">保存</el-button> -->
        </p>
        <div class="joint-structure">
          <div class="paternal">
            <div style="height:15px;border-left: 1px solid #c3bfb9"></div>
            <div class="paternal-1">
              <i class="wl-icon-jianhao"></i>
              {{ CourseName }}
            </div>
            <div style="height:400px;border-left: 1px solid #c3bfb9;margin-top: 16px;"></div>
          </div>
          <div :class="'grandpa_1' + index" v-for="(item, index) in indexlist1" :key="index.num">
            <div
              style="height:15px;border-left: 1px solid #c3bfb9"
              v-if="index == '0' || index == '1'"
            ></div>
            <div style="height:250px;border-left: 1px solid #c3bfb9" v-if="index == '2'"></div>
            <div class="grandpa-1" v-if="radioNum1 == '一'">
              <i class="wl-icon-jianhao"></i>
              {{ Part1.replace('\{\{index\}\}', ' ' + item.type) }}
            </div>
            <div class="grandpa-1" v-if="radioNum1 == '1'">
              <i class="wl-icon-jianhao"></i>
              {{ Part1.replace('\{\{index\}\}', ' ' + item.num) }}
            </div>
          </div>
          <div :class="'parent_2' + index1" v-for="(item, index1) in indexlist2" :key="index1.num">
            <div
              style="height:15px;border-left: 1px solid #c3bfb9"
              v-if="index1 == '0' || index1 == '1'"
            ></div>
            <div
              style="height:100px;border-left: 1px solid #c3bfb9;margin-top: 16px;"
              v-if="index1 == '2'"
            ></div>
            <div class="parent-1" v-if="radioNum2 == '一'">
              <i class="wl-icon-jianhao"></i>
              {{ Part11.replace('\{\{index\}\}', ' ' + item.type) }}
            </div>
            <div class="parent-1" v-if="radioNum2 == '1'">
              <i class="wl-icon-jianhao"></i>
              {{ Part11.replace('\{\{index\}\}', ' ' + item.num).replace('\{\{x\}\}', ' ' + 2) }}
            </div>
          </div>
          <div :class="'son_3' + index2" v-for="(item, index2) in indexlist3" :key="index2.num">
            <div style="height:15px;border-left: 1px solid #c3bfb9"></div>
            <div class="son-1" v-if="radioNum3 == '一'">
              <i class="wl-icon-dian1"></i>
              {{ Unit1.replace('\{\{index\}\}', ' ' + item.type) }}
            </div>
            <div class="son-1" v-if="radioNum3 == '1'">
              <i class="wl-icon-dian1"></i>
              {{ Unit1.replace('\{\{index\}\}', ' ' + item.num).replace('\{\{y\}\}', ' ' + 2).replace('\{\{x\}\}', ' ' + 2) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let id = 1000;
export default {
  data() {
    return {
      indexlist1: [
        { type: '一', num: '1' },
        { type: '二', num: '2' },
        { type: '三', num: '3' }
      ],
      indexlist2: [
        { type: '一', num: '1' },
        { type: '二', num: '2' },
        { type: '三', num: '3' }
      ],
      indexlist3: [{ type: '一', num: '1' }, { type: '二', num: '2' }],
      num1: [
        { name: '第一章', lab: '第{{index}}章', num: '一' },
        { name: '第一讲', lab: '第{{index}}讲', num: '一' },
        { name: '第一课', lab: '第{{index}}课', num: '一' },
        { name: '第一周', lab: '第{{index}}周', num: '一' },
        { name: '第一单元', lab: '第{{index}}单元', num: '一' },
        { name: '第一部分', lab: '第{{index}}部分', num: '一' },
        { name: '模块一', lab: '模块{{index}}', num: '一' },
        { name: '情景一', lab: '情景{{index}}', num: '一' },
        { name: '项目一', lab: '项目{{index}}', num: '一' },
        { name: 'Chapter1', lab: 'Chapter{{index}}', num: '1' },
        { name: '项目1', lab: '项目{{index}} ', num: '1' },
        { name: 'Unit1', lab: 'Unit{{index}}', num: '1' },
        { name: 'Lession1', lab: 'Lession{{index}}', num: '1' },
        { name: 'Part1', lab: 'Part{{index}}', num: '1' },
        { name: '主题1', lab: '主题{{index}}', num: '1' },
        // { name: '模块1', lab: '模块{{index}}', num: '1' }
      ],
      num2: [
        { name: '第一节', lab: '第{{index}}节', num: '一' },
        { name: '第1单元', lab: '第{{index}}单元', num: '1' },
        { name: '第1课', lab: '第{{index}}课', num: '1' },
        { name: '第1讲', lab: '第{{index}}讲', num: '1' },
        { name: '第1部分', lab: '第{{index}}部分', num: '1' },
        { name: '任务1', lab: '任务{{index}}', num: '1' },
        { name: '项目1', lab: '项目{{index}}', num: '1' },
        { name: 'Unit1', lab: 'Unit{{index}}', num: '1' },
        { name: 'Part1', lab: 'Part{{index}}', num: '1' },
        { name: 'Lession1', lab: 'Lession{{index}}', num: '1' },
        { name: '1.1', lab: '{{x}}.{{index}}', num: '1' },
        { name: '单元1', lab: '单元{{index}}', num: '1' }
      ],
      num3: [
        { name: '第一节', lab: '第{{index}}节', num: '一' },
        { name: '第1单元', lab: '第{{index}}单元', num: '1' },
        { name: '第1课', lab: '第{{index}}课', num: '1' },
        { name: '第1讲', lab: '第{{index}}讲', num: '1' },
        { name: '第1部分', lab: '第{{index}}部分', num: '1' },
        { name: '任务1', lab: '任务{{index}}', num: '1' },
        { name: '项目1', lab: '项目{{index}}', num: '1' },
        { name: 'Unit1', lab: 'Unit{{index}}', num: '1' },
        { name: 'Part1', lab: 'Part{{index}}', num: '1' },
        { name: 'Lession1', lab: 'Lession{{index}}', num: '1' },
        { name: '知识点1', lab: '知识点{{index}}', num: '1' },
        { name: '1.1.1', lab: '{{x}}.{{y}}.{{index}}', num: '1' }
      ],
      radio1: '第{{index}}章',
      radioNum1: '一',
      radio2: '第{{index}}节',
      radioNum2: '一',
      radio3: '第{{index}}节',
      radioNum3: '一',
      Part1: '第{{index}}章',
      Part11: '第{{index}}节',
      Unit1: '第{{index}}节',
      LevelData: [],
      CourseName: '',
    };
  },
  props: {
    courseId: {
      type: String,
      default: ''
    },
    saveConfige:{
      type: Boolean,
      default: false
    }
  },
  watch:{
    saveConfige:function(val){
      debugger;
      if(val==true){
        this.saveRadioChange();
      }
    }
  },
  created() {
    this.getCatalogConfig(this.courseId);
    this.getCourseName();
  },
  methods: {
    getCatalogConfig(courseId) {
      let self = this;
      this.$http.post('/api/XOrg/BookMaterialCatalog/getCoursewareCatalogConfig', {
          courseId: courseId
        }).then(function(res) {
          if (res.code > 0) {
            self.LevelData = res.levelData;
            self.Part1 = res.levelData.Level1Format;
            self.radioNum1 = res.levelData.Level1Num;
            self.Part11 = res.levelData.Level2Format;
            self.radioNum2 = res.levelData.Level2Num;
            self.Unit1 = res.levelData.Level3Format;
            self.radioNum3 = res.levelData.Level3Num;
            self.radio1 = res.levelData.Level1Format;
            self.radio2 = res.levelData.Level2Format;
            self.radio3 = res.levelData.Level3Format;
          }
        });
    },
    getCourseName() {
      let self = this;
      this.$http.post('/api/XOrg/BookMaterialCatalog/getCourseName', {
          courseId: this.courseId
        })
        .then(function(res) {
          if (res.code > 0) {
            self.CourseName = res.courseName;
          }
        });
    },
    saveRadioChange() {
      let self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/addOrEditCatalog', {
        courseId: this.courseId,
        Level1Format: this.radio1,
        Level1Num: this.radioNum1,
        Level2Format: this.radio2,
        Level2Num: this.radioNum2,
        Level3Format: this.radio3,
        Level3Num: this.radioNum3
      }).then(function(res) {
        if (res.code > 0) {
          self.$message.success(res.msg);
          self.$emit("sendClose");
        } else {
          self.$message.warning(res.msg);
        }
        self.saveConfige=false;
      });
    },
    radio1_change(name, num) {
      this.Part1 = this.radio1;
      this.radioNum1 = num;
    },
    radio2_change(name, num) {
      this.Part11 = this.radio2;
      this.radioNum2 = num;
    },
    radio3_change(name, num) {
      this.Unit1 = this.radio3;
      this.radioNum3 = num;
    }
  }
};
</script>
